import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "currentTotals",
    "newTotals",
    "newTotalsStandard",
    "newTotalsPayPerWashFleet",
    "newMonthlyTotal",
    "newVehiclesCount",
    "planCount",
  ];

  static values = {
    currentMonthlyTotal: Number,
    currentVehicleCount: Number,
    allFleetVehiclesPayPerWash: Boolean,
    hasMaintenance: Boolean,
    planPrices: String,
  };

  calculateNewTotals() {
    const planPrices = JSON.parse(this.planPricesValue);

    const additionalCount = this.planCountTargets.reduce((acc, planCountElement) => {
      const parsedCount = parseInt(planCountElement.value);
      const count = isNaN(parsedCount) ? 0 : parsedCount;

      return acc + count;
    }, 0);

    const additionalTotal = this.planCountTargets.reduce((acc, planCountElement) => {
      const planId = planCountElement.dataset.planId;
      const parsedCount = parseInt(planCountElement.value);
      const count = isNaN(parsedCount) ? 0 : parsedCount;
      const total = (count * planPrices[planId] * 100) / 100; // round to 2 decimal places

      return acc + total;
    }, 0);

    const newCount = this.currentVehicleCountValue + additionalCount;
    const newTotal = this.currentMonthlyTotalValue + additionalTotal;

    if (additionalCount > 0) {
      const newTotalFormatted = newTotal.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      this.newVehiclesCountTarget.textContent = newCount;
      this.newMonthlyTotalTarget.textContent = `$${newTotalFormatted}`;

      const onlyPayPerWashAdditions = this.allFleetVehiclesPayPerWashValue && additionalTotal === 0;

      if (onlyPayPerWashAdditions) {
        this.newTotalsStandardTarget.classList.add("hidden");
        this.newTotalsPayPerWashFleetTarget.classList.remove("hidden");
        if (this.hasMaintenanceValue) {
          this.newTotalsPayPerWashFleetTarget.textContent = `Recurring monthly charges: $${newTotalFormatted}. You'll have ${newCount} vehicles on pay per wash.`;
        } else {
          this.newTotalsPayPerWashFleetTarget.textContent = `You'll have ${newCount} vehicles on pay per wash. There is no monthly vehicle subscription fee.`;
        }
      } else {
        this.newTotalsStandardTarget.classList.remove("hidden");
        this.newTotalsPayPerWashFleetTarget.classList.add("hidden");
      }

      this.currentTotalsTarget.classList.remove("hidden");
      this.newTotalsTarget.classList.remove("hidden");
    } else {
      this.newTotalsStandardTarget.classList.remove("hidden");
      this.newTotalsPayPerWashFleetTarget.classList.add("hidden");
      this.currentTotalsTarget.classList.add("hidden");
      this.newTotalsTarget.classList.add("hidden");
    }
  }
}
